/**
 * Order Context - the guest's order preferences (pickup / delivery).
 *
 * The cart, totals and order placement live in CartContext + CheckoutPage
 * (the server prices the order); nothing here computes money.
 */

import React, { createContext, useContext, useState } from 'react';

const OrderContext = createContext(null);

export function OrderProvider({ children }) {
  const [orderType, setOrderType] = useState('pickup'); // pickup, delivery
  const [deliveryAddress, setDeliveryAddress] = useState(null);
  const [scheduledTime, setScheduledTime] = useState(null); // null = ASAP

  return (
    <OrderContext.Provider value={{
      orderType,
      deliveryAddress,
      scheduledTime,
      setOrderType,
      setDeliveryAddress,
      setScheduledTime,
    }}>
      {children}
    </OrderContext.Provider>
  );
}

export const useOrder = () => {
  const context = useContext(OrderContext);
  if (!context) {
    throw new Error('useOrder must be used within an OrderProvider');
  }
  return context;
};
